import { render, staticRenderFns } from "./YHStaffManagement.vue?vue&type=template&id=f18ec5ac&scoped=true"
import script from "./YHStaffManagement.vue?vue&type=script&lang=js"
export * from "./YHStaffManagement.vue?vue&type=script&lang=js"
import style0 from "./YHStaffManagement.vue?vue&type=style&index=0&id=f18ec5ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18ec5ac",
  null
  
)

export default component.exports